import { computeCompositePlu } from 'utils/vendor-config';

import { IComputeItemOptionModifierPlu } from './types';

export const computePluForItemOptionModifier = ({
  item,
  modifier,
  vendor,
}: IComputeItemOptionModifierPlu) => {
  return computeCompositePlu({
    parent: item,
    child: modifier,
    vendor,
  });
};
